<template>
  <div class="md-layout" id="about-upm-upload-container">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">{{ formTitle }}</h4>
          </div>
        </md-card-header>

        <md-card-content>
          <div class="md-layout text-center">
            <div class="md-layout-item md-size-100 md-xsmall-size-100">
              <div class="md-layout">
                <label
                  class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label"
                  :for="$t('management_content.about_upm_institute')"
                >
                  {{ $t("management_content.banner") }}
                </label>
                <div
                  class="md-layout-item md-size-100 md-xsmall-size-100"
                  id="vue-upload-multiple-image-content"
                >
                  <vue-upload-multiple-image
                    :is-edit-mode="isEditMode"
                    :data-images="displayImages"
                    accept="image/jpeg,image/png,image/jpg"
                    :maxImage="maxImage"
                    @showModalUploadImage="showModalUploadImage"
                    @removeImage="removeImage"
                    @setAvatar="setAvatar"
                    :avatar="upmAvatar"
                    :primary-text="$t('modal.is_avatar')"
                    :mark-is-primary-text="$t('modal.set_avatar')"
                    :confirm-set-avatar-text="
                      $t('modal.confirm_set_avatar_text')
                    "
                    :confirm-remove-image-text="
                      $t('modal.confirm_remove_image_text')
                    "
                    :add-image-text="$t('modal.add_image')"
                    :remove-img-text="$t('modal.remove_image')"
                  ></vue-upload-multiple-image>
                </div>
              </div>

              <div class="md-layout-item md-size-100 md-xsmall-size-100">
                <div class="md-layout">
                  <!--   About upm  rating system  -->
                  <div class="md-layout-item md-size-50 md-xsmall-size-100">
                    <div class="md-layout">
                      <label
                        class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label"
                        :for="$t('management_content.about_upm_rating_system')"
                      >
                        {{ $t("management_content.about_upm_rating_system") }}
                      </label>
                      <div class="md-layout-item md-size-80 md-xsmall-size-100">
                        <md-field>
                          <md-file
                            @md-change="changeAboutUpmRating"
                            accept="*"
                            v-model="aboutUpmRating"
                          >
                          </md-file>
                        </md-field>
                      </div>
                    </div>
                  </div>

                  <!--   About upm Institute    -->
                  <div class="md-layout-item md-size-50 md-xsmall-size-100">
                    <div class="md-layout">
                      <label
                        class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label"
                        :for="$t('management_content.about_upm_institute')"
                      >
                        {{ $t("management_content.about_upm_institute") }}
                      </label>
                      <div class="md-layout-item md-size-80 md-xsmall-size-100">
                        <md-field>
                          <md-file
                            @md-change="changeAboutInstitute"
                            accept="*"
                            v-model="aboutUpmInstitute"
                          >
                          </md-file>
                        </md-field>
                      </div>
                    </div>
                  </div>

                  <!--   Uni methodology    -->
                  <div class="md-layout-item md-size-50 md-xsmall-size-100">
                    <div class="md-layout">
                      <label
                        class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label"
                        :for="$t('management_content.university_methodology')"
                      >
                        {{ $t("management_content.university_methodology") }}
                      </label>
                      <div class="md-layout-item md-size-80 md-xsmall-size-100">
                        <md-field>
                          <md-file
                            @md-change="changeUniMethodology"
                            accept="*"
                            v-model="uniMethodology"
                          >
                          </md-file>
                        </md-field>
                      </div>
                    </div>
                  </div>

                  <!--  Program methodology  -->
                  <div class="md-layout-item md-size-50 md-xsmall-size-100">
                    <div class="md-layout">
                      <label
                        class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label"
                        :for="$t('management_content.program_methodology')"
                      >
                        {{ $t("management_content.program_methodology") }}
                      </label>
                      <div class="md-layout-item md-size-80 md-xsmall-size-100">
                        <md-field>
                          <md-file
                            @md-change="changeProgramMethodology"
                            accept="*"
                            v-model="programMethodology"
                          >
                          </md-file>
                        </md-field>
                      </div>
                    </div>
                  </div>

                  <!--  Ads gif  -->
                  <div class="md-layout-item md-size-50 md-xsmall-size-100">
                    <div class="md-layout">
                      <label
                        class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label"
                        :for="$t('management_content.ads_document')"
                      >
                        {{ $t("management_content.ads_document") }}
                      </label>
                      <div class="md-layout-item md-size-80 md-xsmall-size-100">
                        <md-field>
                          <md-file
                            @md-change="changeAdsGif"
                            accept="*"
                            v-model="adsGif"
                          >
                          </md-file>
                        </md-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </md-card-content>

        <!--        <md-card-actions-->
        <!--          class="text-center"-->
        <!--          style="justify-content: center!important;"-->
        <!--        >-->
        <!--          <md-button type="submit" class="md-success"-->
        <!--            >{{ $t("common.save") }}-->
        <!--          </md-button>-->
        <!--        </md-card-actions>-->
      </md-card>
    </div>
    <crop-upload-image-modal
      :modal-data="modalAvatar"
      :origin-img-src="uploadedImage"
      :min-container-width="340"
      :min-container-height="260"
      :background="true"
      :rotatable="false"
      :img-style="{ width: '320px', height: '220px' }"
      :aspect-ratio="16 / 9"
      :click-outside-to-close="false"
      @closeModal="closeModalUploadImage"
      @setCroppedImageSrc="insertImage"
      :auto-crop-area="1"
    ></crop-upload-image-modal>
  </div>
</template>

<script>
import { AboutsService } from "../../../services/abouts.service";
import VueUploadMultipleImage from "../../../components/VueUploadMultipleImage/VueUploadMultipleImage";
import CropUploadImageModal from "../../../components/VueUploadMultipleImage/CropUploadImageModal";
import queryHelper from "@/helpers/query-helper";
import { BannerService } from "../../../services/banner.service";

export default {
  name: "AboutUPMIndex",
  components: { CropUploadImageModal, VueUploadMultipleImage },
  data() {
    return {
      formTitle: this.$t("page_title.manage_content_upm"),
      maxImage: 10,
      images: [],
      isEditMode: true,
      modalAvatar: {
        show: false,
        action: "create"
      },
      displayImages: [],
      uploadedImage: "",
      upmAvatar: "",

      aboutUpmRating: null,
      aboutUpmInstitute: null,
      uniMethodology: null,
      programMethodology: null,
      adsGif: null,
      avatarId: null,
      params: {
        avatar: null
      }
    };
  },
  mounted() {
    this.getListBanners();
    this.getUpmFile("about-upm-rating");
    this.getUpmFile("about-upm-institute");
    this.getUpmFile("university-methodology");
    this.getUpmFile("program-methodology");
    this.getUpmFile("ads-gif");
  },
  methods: {
    async getListBanners() {
      const response = await new BannerService().getList({});
      let images = response.data || [];
      if (!images) return;

      let listImage = [];
      let listDisplayImage = [];
      let upmAvatarUrl = null;
      let vm = this;
      for (let i = 0; i < images.length; i++) {
        if (images[i].type === "avatar") {
          vm.avatarId = images[i].id;
          vm.params.avatar = images[i];
          upmAvatarUrl = images[i].url;
          continue;
        }
        listImage.push(images[i]);
        listDisplayImage.push(images[i].url);
      }
      this.upmAvatar = upmAvatarUrl;
      this.images = listImage;
      this.displayImages = listDisplayImage;
    },
    async getUpmFile(type) {
      const response = await new AboutsService().getList({
        type: type
      });
      const data = response.data;
      if (!data) return;
      switch (type) {
        case "about-upm-rating":
          this.aboutUpmRating = data[0]?.file;
          break;
        case "about-upm-institute":
          this.aboutUpmInstitute = data[0]?.file;
          break;
        case "university-methodology":
          this.uniMethodology = data[0]?.file;
          break;
        case "program-methodology":
          this.programMethodology = data[0]?.file;
          break;
        case "ads-gif":
          this.adsGif = data[0]?.file;
          break;
        default:
          break;
      }
    },
    async saveUpmFile(file, type) {
      let params = queryHelper.buildFormData({
        file: file,
        type: type
      });

      const response = await new AboutsService().saveFile(params);
      if (!response) return;
      this.$notify({
        title: this.$t("common.updated"),
        text: this.$t("common.updated_sucess"),
        type: "success"
      });
    },
    closeModalUploadImage() {
      this.modalAvatar.show = false;
      this.$store.commit("DESTROY_MODAL");
    },
    showModalUploadImage(action) {
      this.modalAvatar.action = action || "create";
      this.modalAvatar.show = true;
      this.$store.commit("SHOW_MODAL");
    },
    insertImage(file, modalData) {
      if (modalData.action !== "changeAvatar") {
        this.appendImage(file);
      }
      this.createImage(file, modalData.action);
    },
    createImage(file, action) {
      let reader = new FileReader();
      let vm = this;

      reader.onload = e => {
        vm.uploadedImage = e.target.result;

        if (!vm.params.avatar) {
          this.createAvatar(file);
          vm.upmAvatar = e.target.result;
          vm.params.avatar = file;
        } else if (action === "changeAvatar") {
          this.updateAvatar(file);
          vm.upmAvatar = e.target.result;
          vm.params.avatar = file;
        }
        if (action === "changeAvatar") {
        } else {
          vm.displayImages.unshift(e.target.result);
        }
      };
      reader.readAsDataURL(file);
    },
    removeImage(index) {
      if (this.images[index].id) {
        this.deleteImage(this.images[index].id);
      }
      this.displayImages.splice(index, 1);
      this.images.splice(index, 1);
    },
    async setAvatar(index) {
      const avatarFile = await this.getFileFromUrl(
        this.images[index].url,
        "file",
        this.images[index].url.split(".").pop()
      );
      await this.updateAvatar(avatarFile);
      this.upmAvatar = this.displayImages[index];
      this.params.avatar = this.images[index];
      this.deleteImage(this.images[index].id);
      this.displayImages.splice(index, 1);
      this.images.splice(index, 1);
    },
    async getFileFromUrl(url, name, defaultType = "image/jpeg") {
      const response = await fetch(url);
      const data = await response.blob();
      return new File([data], name, {
        type: response.headers.get("content-type") || defaultType
      });
    },
    appendImage(file) {
      let params = {
        type: "banner",
        url: file
      };
      let formData = queryHelper.buildFormData(params);
      const response = new BannerService().create(formData);
      if (!response) {
        return;
      }
      this.images.unshift(response.url);
      this.$notify({
        title: this.$t("common.updated"),
        text: this.$t("common.updated_sucess"),
        type: "success"
      });
    },
    createAvatar(file) {
      let params = {
        type: "avatar",
        url: file
      };
      let formData = queryHelper.buildFormData(params);
      const response = new BannerService().create(formData);
      if (!response) {
        return;
      }
      this.$notify({
        title: this.$t("common.updated"),
        text: this.$t("common.updated_sucess"),
        type: "success"
      });
    },
    updateAvatar(file) {
      let params = {
        type: "avatar",
        url: file,
        _method: "PUT"
      };
      let formData = queryHelper.buildFormData(params);
      const response = new BannerService().update(this.avatarId, formData);
      if (!response) {
        return;
      }
      this.$notify({
        title: this.$t("common.updated"),
        text: this.$t("common.updated_sucess"),
        type: "success"
      });
    },
    deleteImage(id) {
      new BannerService().delete(id);
    },
    changeAboutUpmRating(file) {
      if (file) {
        this.aboutUpmRating = file[0];
        this.saveUpmFile(file[0], "about-upm-rating");
      }
    },
    changeAboutInstitute(file) {
      if (file) {
        this.aboutUpmInstitute = file[0];
        this.saveUpmFile(file[0], "about-upm-institute");
      }
    },
    changeUniMethodology(file) {
      if (file) {
        this.uniMethodology = file[0];
        this.saveUpmFile(file[0], "university-methodology");
      }
    },
    changeProgramMethodology(file) {
      if (file) {
        this.programMethodology = file[0];
        this.saveUpmFile(file[0], "program-methodology");
      }
    },
    changeAdsGif(file) {
      if (file) {
        this.programMethodology = file[0];
        this.saveUpmFile(file[0], "ads-gif");
      }
    }
  }
};
</script>

<style scoped lang="scss">
#vue-upload-multiple-image-content {
  margin-bottom: 50px;
}
</style>
